import { Link } from "react-router-dom";
import { useLang } from "../context/LangContext";

const IMG = "/founder-pn28.webp";

const TEXT = {
  de: [
    "Ach, die gute alte Zeit, oder? Das Tauschen. Das Sammeln. Die Jagd nach der nächsten besonderen Karte.",
    "Ja, genau! Schon damals haben wir Karten gejagt. Ich erinnere mich noch, wie unbedingt ich ein Pikachu haben wollte. Ein Booster nach dem anderen, bis ich es endlich in den Händen hielt.",
    "Aber während man nach dieser einen Karte sucht, entdeckt man plötzlich so viele andere Pokémon. Einige kannte ich schon aus der Zeichentrickserie, die ich so gerne geschaut habe, oder aus dem Pokémon-Manga Pokémon Pocket Monsters.",
    "Blitza ist bis heute eines meiner absoluten Lieblings-Pokémon. Es gibt noch zwei weitere, aber welche das sind, dürft ihr im Laufe der Zeit selbst herausfinden ...",
    "Aus diesen Kindheitserinnerungen entstand Jahre später pokenewb28.",
    "Heute beginnt mit Jolgen Cards ein neues Kapitel. Aber das Gefühl von damals ist geblieben.",
    "Ich möchte es kurz halten: Ich wünsche mir, dass jeder die Möglichkeit hat, Karten zu sammeln, zu tauschen und sich daran zu erfreuen – genauso, wie ich es damals getan habe.",
    "Denn für mich waren es nie einfach nur Karten. Sie sind Teil einiger meiner schönsten Kindheitserinnerungen. Und vielleicht wird Jolgen Cards eines Tages auch Teil eurer Erinnerungen."
  ],

  en: [
    "The good old days, right? The trading. The collecting. The chase for that one special card.",
    "That's right! Even back then, we were chasing cards. I still remember how badly I wanted a Pikachu. One booster pack after another, until I finally pulled it.",
    "But here's the thing about chasing that one card. Along the way, you start discovering so many other Pokémon. Some I already knew from the cartoon I loved watching or from the Pokémon manga, Pokémon Pocket Monsters.",
    "Jolteon is still one of my all-time favorite Pokémon. There are two others, but I'll let you discover those along the way ...",
    "Years later, those childhood memories became pokenewb28.",
    "Today, Jolgen Cards is the next chapter. But that feeling from back then? It never really went away.",
    "I'll keep it short. I want everyone to have the chance to collect, trade, and enjoy cards the way I used to.",
    "Because to me, they were never just cards. They became part of some of my greatest childhood memories. And maybe, one day, Jolgen Cards will become part of yours too."
  ],
};

export default function About() {
  const { t, lang } = useLang();
  return (
    <div className="bg-[#F7F5FB]">
      <section className="bg-[#120E1F] grain">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-20 lg:py-28">
          <p className="text-xs uppercase tracking-[0.25em] text-[#F2C230]">{t("story_kicker")}</p>
          <h1 className="font-display text-5xl sm:text-6xl lg:text-7xl text-white mt-4 leading-[1.05]" data-testid="about-title">{t("story_title")}</h1>
          <p className="font-display italic text-2xl text-[#C9B6F2] mt-6">{t("slogan")}</p>
        </div>
      </section>
      <section className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-20 grid md:grid-cols-5 gap-12">
        <div className="md:col-span-3 space-y-6 text-[#120E1F]/80 text-lg leading-relaxed">
          {TEXT[lang].map((p, i) => <p key={p.slice(0, 24)} className={i === 0 ? "first-letter:font-display first-letter:text-6xl first-letter:float-left first-letter:mr-3 first-letter:text-[#F2C230]" : ""}>{p}</p>)}
          <p className="font-display italic text-2xl text-[#120E1F] pt-4">— pokenewb28, {lang === "de" ? "Gründer" : "Founder"}</p>
        </div>
        <img src={IMG} alt="pokenewb28 – Gründer von Jolgen Cards" data-testid="about-founder-image" className="md:col-span-2 rounded-[28px] object-cover w-full aspect-square self-start ring-1 ring-[#8A5CD6]/40" />
      </section>
      <section className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 pb-24 grid sm:grid-cols-2 lg:grid-cols-4 gap-4">
        {["v1", "v2", "v3", "v4"].map((k) => (
          <div key={k} className="bg-white rounded-2xl border border-[#120E1F]/5 p-6"><p className="font-display text-xl text-[#120E1F]">{t(k)}</p><p className="text-sm text-[#707783] mt-2">{t(`${k}d`)}</p></div>
        ))}
        <Link to="/shop" data-testid="about-shop-btn" className="btn-gold sm:col-span-2 lg:col-span-4 justify-center mt-6">{t("hero_cta")}</Link>
      </section>
    </div>
  );
}
